import { accessNested } from 'utils/utils';

export default function passToIframe() {

	function getCookie(name) {
		let decodedCookie = document.cookie;
		let cookies = decodedCookie.split(';').map(c => c.trim());
		let matching = cookies.find(cookie => cookie.indexOf(name) === 0);
		return matching;
	}
	let OptanonConsent = getCookie('OptanonConsent');
	let OptanonAlertBoxClosed = getCookie('OptanonAlertBoxClosed');

	const isIframed = window.self !== window.top;
	// We won't need this after we confirm demo stage.
	if (!isIframed) {
		//parent
		let pass_data = {
			OptanonConsent,
			OptanonAlertBoxClosed,
			OptanonActiveGroups: window.OptanonActiveGroups
		};
		for (let i = 0; i < window.frames.length; i++) {
			if (typeof window.frames[i].postMessage === 'function') {
				window.frames[i].postMessage(pass_data, '*');
			}
		}

	}
}

export function listenToIframe() {
	const isIframed = window.self !== window.top;

	if (isIframed) {
		window.addEventListener('message', (event) => {
			let data = event && event.data;
			if (!data || typeof data !== 'object' || !data.OptanonActiveGroups) {
				return;
			}
			if (window.Optanon) {
				let cookie = null;
				const now = new Date();
				const inOneYear = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate());

				setTimeout(() => {
					if (data.OptanonConsent) {
						cookie = data.OptanonConsent;
						document.cookie = `${cookie};expires=${new Date(inOneYear).toUTCString()};path=/;SameSite=None;Secure`;
					}
					if (data.OptanonAlertBoxClosed) {
						cookie = data.OptanonAlertBoxClosed;
						document.cookie = `${cookie};expires=${new Date(inOneYear).toUTCString()};path=/;SameSite=None;Secure`;
					}

					if (data.OptanonActiveGroups) {
						window.OnetrustActiveGroups = data.OptanonActiveGroups;
						window.OptanonActiveGroups = data.OptanonActiveGroups;
					}

					setTimeout(() => {
						let t = new CustomEvent('consent.onetrust', {
							detail: data.OptanonActiveGroups.split(',').filter(e => e)
						});
						window.dispatchEvent(t);

						if (window.dataLayer) {
							window.dataLayer.push({
								event: 'OneTrustGroupsUpdated',
								OptanonActiveGroups: data.OptanonActiveGroups,
								OnetrustActiveGroups: data.OptanonActiveGroups
							});
						}
					});
				});
			}
		});
		const showtimesOneTrust = accessNested(window.__INITIAL_STATE__, 'appData.apis.tracking.oneTrust', {});
		const boltOneTrust = accessNested(window.__INITIAL_STATE__, 'appData.options.oneTrustCookieConsent', {});
		if (showtimesOneTrust.displayInIframe || boltOneTrust.displayInIframe) {
			setTimeout(checkAndHideOneTrust, 100);
		}
	}
}

function checkAndHideOneTrust() {
	let checkAndHideStart = Date.now();
	const oneTrustWrappers = ['#onetrust-consent-sdk', '#optanon'];
	const optanonElement = [...document.querySelectorAll(oneTrustWrappers)].find(x => !!x);
	if (optanonElement) {
		let alertBoxWrappers = document.getElementsByClassName('optanon-alert-box-wrapper');
		if (alertBoxWrappers && alertBoxWrappers.length) {
			alertBoxWrappers[0].style.display = 'none';
		}
		optanonElement.style.display = 'none';
		return;
	}

	// Not found yet, keep checking
	if (Date.now() - checkAndHideStart < 30000) {
		setTimeout(checkAndHideOneTrust, 100);
	}
}
